import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const fallbackId = 'thea-seo-fallback';
const normalized = (path: string) => path.replace(/\/+$/, '') || '/';

/** Keep the public HTML readable until its interactive replacement has data. */
export function prepareSeoFallback(): void {
  const root = document.getElementById('root');
  const fallback = document.getElementById(fallbackId);
  if (!root || !fallback || !root.contains(fallback)) return;
  root.before(fallback);
  root.hidden = true;
}

export function completeSeoHandoff(): void {
  document.getElementById(fallbackId)?.remove();
  const root = document.getElementById('root');
  if (root) root.hidden = false;
}

/** Route changes must never leave a previous page's fallback covering the app. */
export function SeoFallbackRouteGuard(): null {
  const { pathname } = useLocation();
  useEffect(() => {
    const fallback = document.getElementById(fallbackId);
    if (fallback && normalized(fallback.dataset.seoPath ?? '') !== normalized(pathname)) {
      completeSeoHandoff();
    }
  }, [pathname]);
  return null;
}

export function useSeoHandoff(ready: boolean): void {
  useEffect(() => { if (ready) completeSeoHandoff(); }, [ready]);
}
